module.exports = __webpack_public_path__ + "media/images/icon/icons8-Available Updates-240cf8ff52ee7a4b68c9b4227e6b11cc.png";